import { createSlice } from "@reduxjs/toolkit";

export const submittedSlice = createSlice({
  name: "submitted",
  initialState: {
    value: false,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { update } = submittedSlice.actions;

export default submittedSlice.reducer;
